import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export const useIsAdmin = () => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const fetchAdminStatus = async (userId: string | null) => {
      try {
        if (!userId) {
          if (isMounted) {
            setIsAdmin(false);
            setLoading(false);
          }
          return;
        }

        const { data: adminUser, error } = await supabase
          .from('admin_users')
          .select('id, is_active')
          .eq('user_id', userId)
          .eq('is_active', true)
          .single();

        if (isMounted) {
          setIsAdmin(!!adminUser && !error);
          setLoading(false);
        }
      } catch (error) {
        console.error('Error checking admin status:', error);
        if (isMounted) {
          setIsAdmin(false);
          setLoading(false);
        }
      }
    };

    const initialize = async () => {
      try {
        const { data: { user } } = await supabase.auth.getUser();
        await fetchAdminStatus(user?.id ?? null);
      } catch (error) {
        console.error('Error initializing admin check:', error);
        if (isMounted) {
          setIsAdmin(false);
          setLoading(false);
        }
      }
    };

    initialize();

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_, session) => {
      setLoading(true);
      const userId = session?.user?.id ?? null;
      setTimeout(() => {
        fetchAdminStatus(userId);
      }, 0);
    });

    return () => {
      isMounted = false;
      subscription.unsubscribe();
    };
  }, []);
 
  return { isAdmin, loading };
};
